import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { LocalStorageService } from "@dodo/local-storage";
import { EnvConfigProvider } from "app/_core/services/env-config.provider";

@Component({
    selector: "callback-dialog",
    templateUrl: "./callback-dialog.component.html",
    styleUrls: ["./callback-dialog.component.scss"],
    standalone: false
})
export class CallbackDialogComponent implements OnInit {
	private _url = "" ;
	callbackFormUrl: SafeResourceUrl;
	product: string;
	defaultParams: any;

	constructor(
		public dialogRef: MatDialogRef<CallbackDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private sanitizer: DomSanitizer,
		private localStorageService: LocalStorageService,
		private __envConfigProvider: EnvConfigProvider
	) {
		const s = document.createElement("script");
		s.type = "text/javascript";
		s.innerHTML =
			"var ua = 'UA-1639020-1'; if (gaData && gaData['UA-1639020-14']) ua = 'UA-1639020-14'; ga('create', ua, 'auto'); ga(function(tracker) " +
			"{ var clientId = tracker.get('clientId'); var frameWindow = document.getElementById('request-callback-iframe').contentWindow; " +
			"frameWindow.postMessage(clientId, location.origin); });";
		document.body.appendChild(s);

		this.product = "Unknown";
		this.defaultParams = {
			source: "website_call_back_link",
			offer_id: "162",
			affiliate_id: "1533",
			aff_sub5: "P",
			affiliate_source: "Website",
		};
	}

	ngOnInit() {
		// utilize Tealium data layer
		if (window.utag && window.utag_data["product_category"]) {
			Object.assign(this.defaultParams, {
				transaction_id: window.utag_data["ut.session_id"],
			});
			this.product = window.utag_data["product_category"];
			if (window.utag_data["product_subcategory"]) {
				this.product =
					this.product +
					" - " +
					window.utag_data["product_subcategory"];
			}
		}
		this._url = this.__envConfigProvider.rqstCallbackUrl();
		this._url = this._url + "?" + "product=" + this.product;


		Object.assign(
			this.defaultParams,
			this.localStorageService.getFromSessionStorage("dm_query_params")
		);
		Object.keys(this.defaultParams).forEach((key) => {
			this._url = this._url + "&" + key + "=" + this.defaultParams[key];
		});
		this.callbackFormUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
			this._url
		);
	}

	public closeDialog(): void {
		this.dialogRef.close();
	}
}
